export const LIGHT_SOY = '#BABCC1';
export const SOY = '#30323B';
